import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import { ddApps, ddApplicationIds, ddClientTokens, initialiseDataDogRUM } from '@clearscore-group/lib.tools.datadog';

export default () => {
    if (canUseDom()) {
        const application = window.__cs__.env.SITE;
        initialiseDataDogRUM(ddApps[application], ddApplicationIds[application], ddClientTokens[application], 1);
    }
};
